/* The Medispa Edit - "Complete Your Medispa Edit" routine block (Om Sri Keshari), 2026-10-06.
   v2 (playbook v2): clinician rules first (table.next: essential, optional, protect for
   the leading product in the bag), then the concern table for any step still missing.
   Cart drawer and cart page. Reads the routine data from
   /?section_id=medispa-medit-data (products with custom.medit "step|concern" and the
   shop table custom.medit_table), works out which of the five routine steps the bag
   already covers, and offers the products for the missing steps with one button.
   - no discount, gift or price change is made here; it only adds products to the bag
   - hidden when the bag holds a Routine Set, and the free sample line is ignored
   - 8 Oct 2026: the note under the button names the gift-ladder level a selection unlocks */
(function () {
  'use strict';
  var CFG = window.MEDIT_CFG;
  if (!CFG || window.__medit) return;
  window.__medit = true;

  var SRC = 'medispa-medit';
  var rawFetch = window.fetch.bind(window);
  var data = null, dataP = null, html = '', sig = '', timer = null, busy = false, again = false;
  var picks = {};            // variant id -> the shopper's own tick or untick
  var shown = [];            // products currently offered

  function money(c) { return '£' + (Math.max(0, c) / 100).toFixed(2); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function img(u) {
    if (!u) return '';
    return u.indexOf('//') === 0 ? 'https:' + u : u;
  }

  function loadData() {
    if (dataP) return dataP;
    dataP = rawFetch('/?section_id=medispa-medit-data', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var el = doc.querySelector('[data-medit-data]');
        var j = JSON.parse(el.textContent);
        if (!j.table || !j.table.steps) throw new Error('no table');
        var by = {};
        (j.products || []).forEach(function (p) {
          var m = String(p.m || '').split('|');
          p.step = m[0] || '';
          p.concern = m[1] || '';
          by[p.h] = p;
        });
        data = { table: j.table, by: by, list: j.products || [] };
        return data;
      })
      .catch(function () { dataP = null; data = null; return null; });
    return dataP;
  }

  function getCart() {
    return rawFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* Which concern is this bag about? Each product votes for its own concern;
     treatment serums count most. A tie goes to the higher-priced product. */
  function bagConcern(items) {
    var T = data.table, votes = {}, top = {};
    items.forEach(function (it) {
      var p = data.by[it.handle];
      if (!p || !p.concern) return;
      var w = (T.weights && T.weights[p.step]) || 1;
      votes[p.concern] = (votes[p.concern] || 0) + w;
      top[p.concern] = Math.max(top[p.concern] || 0, it.price || 0);
    });
    var best = null;
    Object.keys(votes).forEach(function (c) {
      if (!best || votes[c] > votes[best] || (votes[c] === votes[best] && top[c] > top[best])) best = c;
    });
    return best && T.concerns[best] ? best : T['default'];
  }

  function pickFor(step, concern, inBag) {
    var T = data.table;
    var h = T.concerns[concern] && T.concerns[concern][step];
    var p = h && data.by[h];
    if (p && p.a && !inBag[p.h]) return p;
    /* fallback: another available product for the same step, same concern first */
    var alt = data.list.filter(function (x) { return x.step === step && x.a && !inBag[x.h]; });
    alt.sort(function (a, b) { return (b.concern === concern) - (a.concern === concern); });
    return alt[0] || null;
  }

  function build(cart) {
    var T = data.table;
    var items = (cart.items || []).filter(function (it) { return it.handle !== CFG.sample; });
    if (!items.length) return { html: '', sig: 'empty' };
    if (items.some(function (it) { return it.product_type === 'Routine Set'; })) return { html: '', sig: 'set' };

    var inBag = {}, have = {};
    items.forEach(function (it) {
      inBag[it.handle] = true;
      var p = data.by[it.handle];
      if (p && p.step) have[p.step] = true;
    });
    var concern = bagConcern(items);
    var done = T.steps.filter(function (s) { return have[s]; }).length;
    var missing = (T.priority || T.steps).filter(function (s) { return !have[s]; });
    /* 1) clinician rules of the products in the bag, leading product first
       2) concern table for steps still missing. One product per step, never a step
       the bag already covers, never a product already in the bag. */
    var recs = [], used = {};
    function push(h, role) {
      var p = data.by[h];
      if (recs.length >= 3 || !p || !p.a || inBag[h] || used[h] || have[p.step]) return;
      if (recs.some(function (r) { return r.step === p.step; })) return;
      used[h] = true;
      recs.push({ step: p.step, p: p, role: p.step === 'protect' ? 'protect' : role });
    }
    var lead = items.filter(function (it) { return data.by[it.handle]; }).sort(function (a, b) {
      var wa = (T.weights && T.weights[data.by[a.handle].step]) || 1, wb = (T.weights && T.weights[data.by[b.handle].step]) || 1;
      return wb - wa || (b.price || 0) - (a.price || 0);
    });
    lead.forEach(function (it) {
      ((T.next && T.next[it.handle]) || []).forEach(function (h, i) { push(h, i === 0 && !recs.length ? 'essential' : 'optional'); });
    });
    missing.forEach(function (s) {
      var p = pickFor(s, concern, inBag);
      if (p) push(p.h, recs.length ? 'optional' : 'essential');
    });
    recs.sort(function (a, b) { return (a.role === 'protect') - (b.role === 'protect'); });
    if (recs[0] && recs[0].role !== 'protect') recs[0].role = 'essential';
    shown = recs;
    /* default = "Recommended": the essential next product plus SPF */
    recs.forEach(function (r, i) { r.on = (r.p.v in picks) ? picks[r.p.v] : (i === 0 || r.role === 'protect'); });
    var miss = T.steps.filter(function (s) { return !have[s]; });
    var names = T.names || {};
    var headline = miss.length === 1
      ? (miss[0] === 'protect' ? 'One final step: protect' : 'Your Medispa Edit is missing its ' + (names[miss[0]] || miss[0]))
      : 'Your Medispa Edit is almost complete';

    var stepsHtml = T.steps.map(function (s) {
      return '<li class="medit__s' + (have[s] ? ' is-on' : '') + '"><span class="medit__dot" aria-hidden="true">' +
        (have[s] ? '<svg viewBox="0 0 24 24"><path d="M5 12.5l4.2 4.2L19 7"/></svg>' : '') + '</span>' +
        '<span class="medit__sl">' + esc(T.labels[s] || s) + '</span>' +
        '<span class="medit__sr"> ' + (have[s] ? 'in your bag' : 'not in your bag') + '</span></li>';
    }).join('');

    var out;
    if (done >= T.steps.length || !recs.length) {
      out = '<div class="medit__head"><p class="medit__t">Your Medispa Edit is complete</p>' +
        '<p class="medit__n">' + T.steps.length + '/' + T.steps.length + '</p></div>' +
        '<ol class="medit__steps">' + stepsHtml + '</ol>' +
        '<p class="medit__sub">All five steps of your routine are in your bag.</p>';
      if (done < T.steps.length) out = '';
    } else {
      out = '<div class="medit__head"><p class="medit__t">' + esc(headline) + '</p><p class="medit__n">' + done + '/' + T.steps.length + '</p></div>' +
        '<ol class="medit__steps">' + stepsHtml + '</ol>' +
        '<p class="medit__sub">Complete the missing steps selected for your routine.</p>' +
        '<ul class="medit__list">' + recs.map(function (r) {
          var p = r.p;
          return '<li><label class="medit__i"><input type="checkbox" data-medit-pick="' + p.v + '"' + (r.on ? ' checked' : '') + '>' +
            '<span class="medit__box" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.2 4.2L19 7"/></svg></span>' +
            (p.i ? '<img class="medit__img" src="' + esc(img(p.i)) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="medit__img"></span>') +
            '<span class="medit__tx"><span class="medit__tag">' + esc(T.labels[r.step] || r.step) + (r.role === 'essential' ? ' · next step' : '') + '</span>' +
            '<span class="medit__name">' + esc(p.t) + '</span></span>' +
            '<span class="medit__pr">' + money(p.p) + '</span></label></li>';
        }).join('') + '</ul>' +
        '<button type="button" class="medit__btn" data-medit-add></button>' +
        '<p class="medit__note" data-medit-note hidden></p>';
    }
    return {
      html: out,
      sig: [done, concern, cart.total_price, recs.map(function (r) { return r.p.v; }).join(',')].join('|'),
      total: cart.total_price || 0,
      done: done, missing: miss, names: names
    };
  }

  var cartTotal = 0;
  var state = { done: 0, missing: [], names: {} };
  var seen = '', wasDone = null;

  /* measurement: Shopify customer events and Microsoft Clarity custom events */
  function track(name, payload) {
    try { window.Shopify.analytics.publish(name, payload || {}); } catch (e) {}
    try { window.clarity('event', name); } catch (e) {}
  }

  function refreshButton(box) {
    var btn = box.querySelector('[data-medit-add]');
    if (!btn) return;
    var sum = 0, n = 0;
    shown.forEach(function (r) { if (r.on) { sum += r.p.p; n++; } });
    btn.disabled = n === 0;
    var label = 'Select a product';
    if (n === 1) {
      var one = shown.filter(function (r) { return r.on; })[0];
      label = 'Add my ' + (state.names[one.step] || 'product');
    } else if (n > 1) {
      var got = {};
      shown.forEach(function (r) { if (r.on) got[r.step] = true; });
      label = state.missing.every(function (s) { return got[s]; }) ? 'Complete your Medispa Edit' : 'Complete my routine';
    }
    btn.textContent = n ? label + ' — ' + money(sum) : label;
    var note = box.querySelector('[data-medit-note]');
    if (note) {
      var R = window.MRW_CFG, msg = '';
      if (R && n) {
        var after = cartTotal + sum;
        /* gift ladder (8 Oct 2026): name the highest gift level this selection reaches */
        var gg = null;
        (R.gifts || []).forEach(function (g) { if (g && g.id && g.min > 0 && cartTotal < g.min && after >= g.min) gg = g; });
        if (gg) msg = cartTotal < R.t1 ? 'Unlocks free UK delivery and ' + gg.name + '.' : 'Unlocks ' + gg.name + '.';
        else if (cartTotal < R.t1 && after >= R.t1) msg = 'Unlocks free UK delivery.';
      }
      note.textContent = msg;
      note.hidden = !msg;
    }
  }

  function place() {
    var spots = [];
    var drawer = document.querySelector('cart-drawer-component .cart-drawer__content');
    if (drawer && !drawer.closest('.cart-drawer--empty')) spots.push({ host: drawer, kind: 'drawer' });
    if (CFG.isCart) {
      document.querySelectorAll('.cart-totals').forEach(function (t) {
        if (!t.closest('cart-drawer-component')) spots.push({ host: t.parentNode, kind: 'page', before: t });
      });
    }
    var keep = [];
    spots.forEach(function (s) {
      var box = s.host.querySelector(':scope > .medit--' + s.kind);
      if (!html) { if (box) box.remove(); return; }
      if (!box) {
        box = document.createElement('div');
        box.className = 'medit medit--' + s.kind;
        box.setAttribute('data-medit', '');
      }
      if (box.getAttribute('data-sig') !== sig) {
        box.innerHTML = html;
        box.setAttribute('data-sig', sig);
      }
      refreshButton(box);
      if (s.kind === 'drawer') {
        /* directly under the bag lines, above the totals */
        var anchor = s.host.querySelector(':scope > .cart-drawer__items, :scope > scroll-hint, :scope > .cart-items__wrapper');
        var items = s.host.querySelector('.cart-drawer__items') || anchor;
        var after = items;
        while (after && after.parentNode !== s.host) after = after.parentNode;
        if (after) { if (after.nextElementSibling !== box) after.insertAdjacentElement('afterend', box); }
        else if (box.parentNode !== s.host) s.host.appendChild(box);
      } else {
        var ref = s.before.previousElementSibling && s.before.previousElementSibling.classList.contains('mrw-slot--page') ? s.before.previousElementSibling : s.before;
        if (ref.previousElementSibling !== box) s.host.insertBefore(box, ref);
      }
      keep.push(box);
    });
    document.querySelectorAll('[data-medit]').forEach(function (b) { if (keep.indexOf(b) < 0) b.remove(); });
  }

  function run() {
    if (busy) { again = true; return; }
    busy = true;
    loadData().then(function (d) {
      if (!d) return null;
      return getCart().then(function (cart) {
        var b = build(cart);
        html = b.html; sig = b.sig; cartTotal = b.total || 0;
        state = { done: b.done || 0, missing: b.missing || [], names: b.names || {} };
        place();
        if (html && document.querySelector('[data-medit]') && seen !== sig) {
          seen = sig;
          if (shown.length && state.missing.length) track('recommendation_view', { products: shown.map(function (r) { return r.p.h; }), steps_done: state.done });
        }
        if (wasDone !== null && wasDone < 5 && state.done >= 5) track('routine_complete', {});
        wasDone = state.done;
      });
    }).catch(function () {}).then(function () {
      busy = false;
      if (again) { again = false; queue(); }
    });
  }
  function queue() { clearTimeout(timer); timer = setTimeout(run, 220); }

  document.addEventListener('cart:update', queue);
  document.addEventListener('cart:refresh', queue);
  var prevFetch = window.fetch;
  window.fetch = function (input) {
    var url = (input && input.url) || input || '';
    var res = prevFetch.apply(window, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) res.then(queue).catch(function () {});
    return res;
  };

  document.addEventListener('change', function (e) {
    var c = e.target && e.target.getAttribute && e.target.getAttribute('data-medit-pick');
    if (!c) return;
    picks[c] = e.target.checked;
    shown.forEach(function (r) { if (String(r.p.v) === c) r.on = e.target.checked; });
    document.querySelectorAll('[data-medit]').forEach(function (box) {
      var other = box.querySelector('[data-medit-pick="' + c + '"]');
      if (other) other.checked = e.target.checked;
      refreshButton(box);
    });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-medit-add]');
    if (!btn) return;
    e.preventDefault();
    var items = shown.filter(function (r) { return r.on; }).map(function (r) { return { id: r.p.v, quantity: 1 }; });
    if (!items.length) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    track('recommendation_add', { products: shown.filter(function (r) { return r.on; }).map(function (r) { return r.p.h; }), placement: CFG.isCart ? 'cart_page' : 'cart_drawer' });
    prevFetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return getCart(); })
      .then(function (cart) {
        if (CFG.isCart) { window.location.reload(); return; }
        try {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: SRC, data: { source: SRC, itemCount: cart.item_count, didError: false } }
          }));
        } catch (err) {}
        queue();
      })
      .catch(function () { sig = ''; queue(); });
  });

  var raf = false;
  new MutationObserver(function () {
    if (raf) return;
    raf = true;
    setTimeout(function () { raf = false; if (data) place(); }, 60);
  }).observe(document.body, { childList: true, subtree: true });

  run();
})();
